import {
  Box,
  Container,
  Flex,
  Heading,
  Text,
} from '@chakra-ui/layout';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import { GiBroom, GiHouseKeys, GiMoneyStack } from 'react-icons/gi';

import { IoMdPaperPlane } from 'react-icons/io';
import { IoWalletOutline } from 'react-icons/io5';
import React from 'react';
import { RiToolsLine } from 'react-icons/ri';
import { generate } from 'shortid';

const whyusSection = [
  {
    icon: (
      <IoMdPaperPlane style={{ height: 'auto', width: '30px' }} />
    ),
    header: 'Offer Within 30 Minutes',
    content:
      'You will get an immediate offer after our walk-through, and we will show you how we calculate your offer with total transparency.',
  },
  {
    icon: (
      <IoWalletOutline style={{ height: 'auto', width: '30px' }} />
    ),
    header: 'Our Services Are Free, We Pay Closing Cost!',
    content:
      'There is zero cost dealing with us, we actually pay the closing cost! Just fill out the form, and we’ll present your offer sooner rather than later, and best of all - there are no obligations to accept our offer.',
  },
  {
    icon: <GiBroom style={{ height: 'auto', width: '30px' }} />,
    header: 'No Need To Clean!',
    content:
      'Take what you want and leave the rest. We’ll take care of all of it for you.',
  },
  {
    icon: <RiToolsLine style={{ height: 'auto', width: '30px' }} />,
    header: 'No Repairs, We Buy as is!',
    content:
      'We buy as is! The offer will most likely be higher if we do not have to undo and redo any repairs you make. We look at your home’s potential, not as it is.',
  },
  {
    icon: <GiHouseKeys style={{ height: 'auto', width: '30px' }} />,
    header: 'No Realtors, No Agents, NO COMMISSIONS!',
    content:
      'We don’t involve any agents or realtors throughout this buying process. No agent fees for you to pay, and most importantly - more money in your pocket.',
  },
  {
    icon: <GiMoneyStack style={{ height: 'auto', width: '30px' }} />,
    header: 'Already Got An Offer? Let Us Try To Beat It!',
    content:
      'Let us try and beat it. There’s nothing wrong with a little competition, we are the best - with the best offers. We are confident that we can beat any offer - just give us a shot and we can make it happen!',
  },
];

const WhyusSection = ({ data = whyusSection, img }) => {
  const image = getImage(img);
  return (
    <Box
      background="brand.three"
      py={10}
    >
      <Container maxW="container.xl">
        <Flex
          alignItems="center"
          justifyContent="space-between"
          mb={10}
          flexWrap="wrap"
        >
          <Box
            flexGrow="1"
            flexBasis={{ base: '100%', md: '50%' }}
          >
            <Heading
              as="h4"
              size="3xl"
            >
              Why Choose Us?
            </Heading>
            <Heading
              as="h5"
              size="lg"
              variant="sec"
            >
              Working with us is hassle free, upfront, and fast...
            </Heading>
          </Box>
          <Box
            flexGrow="1"
            flexBasis={{ base: '100%', md: '50%' }}
            className="height-300 "
            display={{ sm: 'none', md: 'block' }}
            position="relative"
            transform={{ base: 'scale(.7)', md: 'scale(1)' }}
          >
            {/* <Box position="absolute">
              <GatsbyImage alt="hero success image" image={flare} />
            </Box> */}
            <Box
              position="absolute"
              top="-10%"
              left="0"
              className="width-600"
            >
              <GatsbyImage
                alt="hero success image"
                image={image}
              />
            </Box>
          </Box>
        </Flex>
        <Flex
          flexDirection="row"
          justifyContent={{ sm: 'center', md: 'space-around' }}
          flexWrap="wrap"
        >
          {data.map((d, i) => (
            <Box
              key={generate()}
              flexBasis={{ base: '100%', md: '50%', lg: '30%' }}
              mb={10}
              position="relative"
              zIndex="1"
            >
              {/* <Box
                zIndex="-1"
                background="brand.three"
                pt={10}
                pl={10}
                top="-20px"
                width="100%"
                height="80%"
                left="20px"
                position="absolute"
                rounded="md"
                boxShadow="xl"
                opacity=".4"
              ></Box> */}
              <Box
                p={{ base: 3, md: 5 }}
                // background="white"
                rounded="md"
                // boxShadow="xl"
              >
                <Box className="minwidth-300">
                  <Box
                    width="70px"
                    height="70px"
                    border="2px"
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    borderColor="gray.700"
                    borderRadius="full"
                  >
                    <Box>{d.icon}</Box>
                  </Box>
                  <Heading
                    as="h5"
                    size="lg"
                    my={4}
                  >
                    {d.header}
                  </Heading>
                  <Text fontSize="xl">{d.content}</Text>
                </Box>
              </Box>
            </Box>
          ))}
        </Flex>
      </Container>
    </Box>
  );
};

export default WhyusSection;

{
  /* <Box
              key={generate()}
              p={{ sm: 3, md: 10 }}
              flexBasis={{ base: '100%', md: '30%' }}
              px={{ base: 0, md: 6 }}
              mb={10}
              background="brand.three"
              rounded="md"
              boxShadow="xl"
            >
              <Box className="width-400">
                <Box
                  width="70px"
                  height="70px"
                  border="2px"
                  padding={4}
                  borderColor="gray.700"
                  borderRadius="full"
                >
                  <Box>{d.icon}</Box>
                </Box>
                <Heading as="h5" size="lg" my={4}>
                  {d.header}
                </Heading>
                <Text fontSize="2xl">{d.content}</Text>
              </Box>
            </Box> */
}
